package com.macrofocus.common.timing

import kotlin.js.Date

actual class Timing {
    private var start: Double = 0.0
    private var end: Double = 0.0

    private var _lastDuration = 0L
    private var duration = 0L
    private var count = 0

    actual val lastDuration: Long
        get() = _lastDuration

    actual val averageDuration: Long
        get() = duration / count

    actual val fps : Int
        get() {
            if(lastDuration > 0) {
                return (1000L / lastDuration).toInt()
            } else {
                return 1000
            }
        }

    actual fun start() {
        start = Date.now()
    }

    actual fun stop() {
        end = Date.now()

        _lastDuration = (end - start).toLong()
        duration += _lastDuration
        count++
    }

    actual fun print() {
        println(toString())
    }

    override fun toString(): String {
        return "Timing(lastDuration=$lastDuration, fps=$fps, averageDuration=$averageDuration)"
    }
}